import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faOilWell } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import styles from '@/modules/market-signals/components/market-signals/market-signals.module.css';

export default function MarketSignalSourceBadge({ source }: { source: string }) {
  let bg = 'bg-info-subtle text-info-emphasis';

  if (source === 'truth-social') bg = 'bg-danger-subtle text-danger-emphasis';
  else if (source === 'website') bg = 'bg-success-subtle text-success-emphasis';
  else if (source === 'pipeline-notification') bg = 'bg-warning-subtle text-warning-emphasis';
  else if (source === 'linkedin') bg = styles['bg-linkedin'];

  return <span className={`badge ${bg}`}>{source}</span>;
}

export function MarketSignalSourceText({
  source,
  children,
}: React.PropsWithChildren<{ source: string }>) {
  let color = 'text-info';

  let icon = <></>;

  if (source === 'truth-social') color = 'text-danger';
  else if (source === 'website') {
    color = 'text-success';
    icon = (
      <>
        <FontAwesomeIcon icon={faGlobe} />{' '}
      </>
    );
  } else if (source === 'twitter/x') {
    icon = <FontAwesomeIcon icon={faXTwitter} />;
  } else if (source === 'pipeline-notification') {
    color = 'text-warning';
    icon = (
      <>
        <FontAwesomeIcon icon={faOilWell} />
      </>
    );
  } else if (source === 'linkedin') {
    color = styles['text-linkedin'];
    icon = (
      <>
        <FontAwesomeIcon icon={faLinkedin} />
      </>
    );
  }

  return (
    <span className={color}>
      {icon} {children}
    </span>
  );
}
